import { render, staticRenderFns } from "./SimpleSelectQuestion.vue?vue&type=template&id=be0d66b6&"
import script from "./SimpleSelectQuestion.vue?vue&type=script&lang=js&"
export * from "./SimpleSelectQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports